<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <ActionButton
          v-if="userCanEdit"
          text="Añadir"
          i="fas fa-file-plus"
          variant="outline-success m-1"
          :responsive="false"
          @click="addSchool"
        />
      </template>
    </page-header>
    <SchoolFilter />
    <CustomSeparator
      text="Lista de Escuelas"
      class="mt-4 custom-separator-line"
    />
    <CustomResultNotFound
      v-if="results.length == 0"
      class="mt-4"
      :text="noResultsText"
    />
    <div class="pt-2">
      <ResultRow
        v-for="(item, index) in results"
        :key="`row-item-${index}`"
        :item="item"
      />
    </div>

    <div v-if="results.length > 9" class="row">
      <div class="col-12 pt-0">
        <pagination :data="pagination" @pagination-go-page="pageChanged" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'pagination';
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import SchoolFilter from './components/SchoolSearch';
import ResultRow from './components/ResultRow';
import { modulesName } from '@/modules';
import {
  actionTypes,
  getterTypes,
} from '@/modules/operation-school-management/store/types';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.operationSchoolManagementModuleName
);
import CustomResultNotFound from 'custom-result-not-found';

const ADD_EDIT_SCHOOL_ROUTE_NAME = 'AddEditSchool';

export default {
  name: 'SchoolManagementMain',
  components: {
    PageHeader,
    CustomSeparator,
    ActionButton,
    SchoolFilter,
    ResultRow,
    Pagination,
    CustomResultNotFound,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-calculator',
        title: 'Manejo de Escuelas',
        routes: ['Inicio', 'Operaciones', 'Manejo de Escuelas'],
      },
      noResultsText: 'No se ha encontrado resultado de escuelas en sistema.',
    };
  },
  computed: {
    ...mapGetters({
      pagination: getterTypes.GET_PAGINATION,
      filter: getterTypes.GET_FILTER,
      results: getterTypes.GET_RESULTS,
    }),
    userCanEdit() {
      return this.$store.getters.HasPermission('school.edit');
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    ...mapActions([actionTypes.FETCH_RESULTS]),
    addSchool() {
      this.$router.push({ name: ADD_EDIT_SCHOOL_ROUTE_NAME });
    },
    getSchools(filters) {
      this.filter.locationSchoolId = filters.locationSchoolId;
      this.filter.schoolType = filters.schoolType;
      this.filter.schoolName = filters.schoolName;
      this[actionTypes.FETCH_RESULTS](filters);
    },
    pageChanged(currentPage) {
      this.pagination.currentPage = currentPage;
      let schoolType = { id: this.filter.schoolType?.id ?? '' };
      const filters = {
        locationSchoolId: this.filter.schoolName?.id ?? '',
        schoolType: schoolType,
        isActive: this.filter.isActive,
        currentPage: currentPage,
      };
      this.getSchools(filters);
    },
    perPageChange(params) {
      let schoolType = { id: this.filter.schoolType?.id ?? '' };
      const filters = {
        locationSchoolId: this.filter.schoolName?.id ?? '',
        schoolType: schoolType,
        isActive: this.filter.isActive,
        count: params.currentPerPage,
      };
      this.getSchools(filters);
    },
    clearFilters() {
      this.filter.schoolName = null;
      this.filter.schoolType = null;
      this.filter.isActive = true;
      this.pagination.currentPage = 1;
    },
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (from.name !== 'AddEditSchool') {
        vm.clearFilters();
      }
      vm.getSchools(vm.filter);
    });
  },
};
</script>
<style scoped>
@media only screen and (max-width: 375px) {
  ::v-deep .separator-custom {
    font-size: 12px !important;
  }
  ::v-deep .separator-custom__text {
    padding: 2px 16px !important;
    font-weight: normal !important;
  }
}
</style>
